import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../../../shared/material/material.module';
import { ProductPackage } from '../../../../core/generated';

export interface PackageDetailsDialogData {
  package: ProductPackage;
  packageTotal: number;
}

@Component({
  selector: 'app-package-details-dialog',
  standalone: true,
  imports: [MaterialModule],
  templateUrl: './package-details-dialog.component.html',
  styleUrl: './package-details-dialog.component.scss'
})
export class PackageDetailsDialogComponent {
  private dialogRef = inject(MatDialogRef<PackageDetailsDialogComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: PackageDetailsDialogData) {}

  onClose(): void {
    this.dialogRef.close();
  }

  formatDate(date?: string): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('pt-BR');
  }

  formatPrice(price?: number): string {
    if (price === undefined || price === null) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(price);
  }

  getItemsCount(): number {
    return this.data.package.items?.length || 0;
  }

  getDiscountsCount(): number {
    return this.data.package.discounts?.length || 0;
  }

  getDiscountTypeLabel(type?: string): string {
    const typeMap: { [key: string]: string } = {
      'PERCENTAGE': 'Porcentagem',
      'FIXED_AMOUNT': 'Valor Fixo',
      'FIXED': 'Valor Fixo'
    };
    return type ? typeMap[type] || type : 'N/A';
  }

  getDiscountPercentage(discount: any): number | null {
    return discount && discount.percentage !== undefined ? discount.percentage : null;
  }

  getDiscountAmount(discount: any): number | null {
    return discount && discount.amount !== undefined ? discount.amount : null;
  }
}
